import React from 'react';
import useTheme from 'src/customizations/themes/hooks/useTheme';
import Row from './Row';
const Grid = ({ cols = 2, spacing = 12, ...rowProps }) => {
    const [{ theme }] = useTheme();
    if (spacing > theme.spacing.page && __DEV__) {
        throw new Error(`Spacing in a Grid cannot be > ${theme.spacing.page}`);
    }
    return (React.createElement(Row, { style: [{
                display: 'grid',
                gridTemplateColumns: `repeat(${cols}, 1fr)`,
                columnGap: `${spacing}px`,
                rowGap: `${spacing}px`,
            }, rowProps.style], ...rowProps }));
};
export default Grid;
